// File Metadata:
// Filename: RoutePreserver.jsx
// Version: 1.00
// Created: 2025-05-07
// Last Modified: 2025-05-07
// Authors: GitHub Copilot
// Description: Component that preserves the current route during page refreshes

import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

const LAST_ROUTE_KEY = 'familysync_last_route';

const RoutePreserver = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { status, data: user } = useSelector(state => state.user);

  // Save the current location to localStorage whenever it changes
  useEffect(() => {
    const currentPath = location.pathname + location.search;
    // Don't save login/signup routes as they should redirect to home when logged in
    if (currentPath !== '/login' && currentPath !== '/signup') {
      localStorage.setItem(LAST_ROUTE_KEY, currentPath);
    }
  }, [location]);

  // When authentication is complete, check if we should restore a previous route
  useEffect(() => {
    if (status === 'succeeded' && user) {
      const lastRoute = localStorage.getItem(LAST_ROUTE_KEY);
      
      // Only restore routes that require authentication
      if (lastRoute && 
          lastRoute !== '/' && 
          lastRoute !== '/login' && 
          lastRoute !== '/signup' &&
          location.pathname === '/') {
        // Short delay to ensure authentication is fully processed
        setTimeout(() => {
          navigate(lastRoute);
        }, 100);
      }
    }
  }, [status, user, navigate, location.pathname]);

  return <>{children}</>;
};

export default RoutePreserver;